module.exports = __webpack_public_path__ + "static/media/aaron_leibowitz.9dfd07b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team/aaron_leibowitz.jpg
// module id = 214
// module chunks = 0